import { Check, ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { CTA_URL } from "../lib/constants";

const ROWS = [
    { feature: "Time to launch", trad: "6+ weeks", diy: "Days of tinkering", em: "Minutes" },
    { feature: "Cost to start", trad: "$5,000+", diy: "Monthly add-ons", em: "Free plan" },
    { feature: "Coding required", trad: "Yes", diy: "For anything custom", em: "None" },
    { feature: "Design quality", trad: "Depends on budget", diy: "Template look", em: "Modern custom UI" },
    { feature: "Making changes", trad: "Email your developer", diy: "Learn the tool", em: "Just ask, in plain words" },
    { feature: "Going live", trad: "You figure it out", diy: "Locked-in hosting", em: "One-click deploy" },
];

export const Comparison = () => (
    <section id="compare" data-testid="comparison-section" className="relative px-6 py-20 sm:py-28">
        <div className="absolute left-1/2 top-1/4 h-[300px] w-[520px] -translate-x-1/2 rounded-full bg-[#8B5CF6]/10 blur-[130px]" aria-hidden="true" />
        <div className="relative mx-auto max-w-5xl">
            <Reveal className="mb-12 text-center sm:mb-14">
                <Eyebrow>Compare</Eyebrow>
                <h2 className="mt-5 font-display text-4xl font-medium tracking-tight text-white sm:text-5xl">
                    Emergent vs. the old way.
                </h2>
                <p className="mx-auto mt-4 max-w-xl text-base text-white/60 sm:text-lg">
                    Same outcome, a fraction of the time and cost.
                </p>
            </Reveal>

            <Reveal>
                <div data-testid="comparison-table" className="hidden overflow-hidden rounded-2xl border border-white/10 bg-[#0A0A0A] md:block">
                    <div className="grid grid-cols-4 border-b border-white/10 bg-[#0D0D0D] text-sm">
                        <div className="p-5" />
                        <div className="p-5 text-center font-medium text-white/50">Traditional dev</div>
                        <div className="p-5 text-center font-medium text-white/50">DIY builders</div>
                        <div className="flex items-center justify-center gap-2 bg-[#8B5CF6]/10 p-5 text-center font-medium text-white">
                            Emergent
                            <span className="rounded-full border border-[#00C2FF]/40 bg-[#00C2FF]/10 px-2 py-0.5 text-[10px] font-medium text-[#00C2FF]">
                                Recommended
                            </span>
                        </div>
                    </div>
                    {ROWS.map((row, i) => (
                        <div
                            key={row.feature}
                            className={`grid grid-cols-4 items-center text-sm ${i < ROWS.length - 1 ? "border-b border-white/5" : ""}`}
                        >
                            <div className="p-5 font-medium text-white/85">{row.feature}</div>
                            <div className="p-5 text-center text-white/45">{row.trad}</div>
                            <div className="p-5 text-center text-white/45">{row.diy}</div>
                            <div className="flex h-full items-center justify-center gap-2 bg-[#8B5CF6]/10 p-5 text-center font-medium text-white">
                                <Check size={15} className="shrink-0 text-[#00C2FF]" />
                                {row.em}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="space-y-4 md:hidden">
                    {ROWS.map((row) => (
                        <div key={row.feature} className="rounded-xl border border-white/10 bg-[#0A0A0A] p-5">
                            <p className="font-medium text-white">{row.feature}</p>
                            <div className="mt-3 space-y-2 text-sm">
                                <div className="flex items-center justify-between gap-4">
                                    <span className="text-white/40">Traditional dev</span>
                                    <span className="text-right text-white/60">{row.trad}</span>
                                </div>
                                <div className="flex items-center justify-between gap-4">
                                    <span className="text-white/40">DIY builders</span>
                                    <span className="text-right text-white/60">{row.diy}</span>
                                </div>
                                <div className="flex items-center justify-between gap-4 border-t border-white/10 pt-2">
                                    <span className="font-medium text-[#00C2FF]">Emergent</span>
                                    <span className="flex items-center gap-1.5 text-right font-medium text-white">
                                        <Check size={14} className="text-[#00C2FF]" />
                                        {row.em}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Reveal>

            <Reveal delay={0.15} className="mt-10 text-center">
                <a
                    href={CTA_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="comparison-cta-button"
                    className="group inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-base font-medium text-black transition-transform duration-200 hover:scale-105"
                >
                    Start Building Free
                    <ArrowRight size={18} className="transition-transform duration-200 group-hover:translate-x-1" />
                </a>
            </Reveal>
        </div>
    </section>
);
